import { ExtensionBridge } from '@doxyme/extensions-bridge';
import { isProduction } from '../../../shared/isProduction';
import { addPropertyToWindow } from '../../../shared/addPropertyToWindow';
import { addSideloadExtensionToWindow } from '../sideloading/sideloadExtension';

export const bridge = new ExtensionBridge();

export const addBridgeToWindow = (): void => {
  if (!isProduction()) {
    addPropertyToWindow<ExtensionBridge>('Bridge', bridge);
  }
};

addBridgeToWindow();
addSideloadExtensionToWindow();
